export const removeElementFromArrayByIndex = (items, index) => [...items.slice(0, index), ...items.slice(index + 1)];
